var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 74,
    viewBox: "0 0 60 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8861 10.7191C55.044 7.60511 52.5486 5.12464 49.4107 3.27771C46.3049 1.42005 42.8564 0.496582 39.0651 0.496582H0.349609V11.2775H39.0651C41.7961 11.2775 44.1201 12.2332 46.0264 14.1553C47.9435 16.0344 48.8966 18.3323 48.8966 21.0383V53.0266C48.8966 55.7004 47.9435 57.9768 46.0264 59.856C44.1094 61.7351 41.7961 62.6801 39.0651 62.6801H11.1557V22.1228H0.349609V62.6586L11.1664 73.5039H39.0651C42.8564 73.5039 46.3049 72.6019 49.4107 70.7872C52.5486 68.9403 55.044 66.4706 56.8861 63.3888C58.7281 60.307 59.6491 56.903 59.6491 53.1662V21.0168C59.6491 17.2156 58.7281 13.7794 56.8861 10.6976V10.7191Z",
    fill: "#FFAE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDLogo);
export default __webpack_public_path__ + "static/media/d-logo.86b4a46584f6f30f84f67e675ae3a49a.svg";
export { ForwardRef as ReactComponent };